import React, { createContext, useContext, useState } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { VanityModalStateContextProvider } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { VanityLinkModal } from '../index';

type VanityLinkModalContextType = {
	openModal: () => void;
	closeModal: () => void;
};

const VanityLinkModalContext = createContext<VanityLinkModalContextType>({
	openModal: () => {},
	closeModal: () => {},
});

export const useVanityLinkModalContext = () => useContext(VanityLinkModalContext);

export const VanityLinkModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const [isOpen, setIsOpen] = useState(false);

	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = () => {
		setIsOpen(false);
	};

	return (
		<VanityLinkModalContext.Provider value={{ openModal, closeModal }} data-qa="vanity-link-modal-context">
			{children}
			{isOpen && (
				<VanityModalStateContextProvider>
					<VanityLinkModal
						isOpen={isOpen}
						onClose={closeModal}
						petitionId={petition.id}
						petitionSlug={petition.slug}
						displayedSignatures={petition.signatureState.signatureCount.displayed}
						data-qa="vanity-link-modal"
					/>
				</VanityModalStateContextProvider>
			)}
		</VanityLinkModalContext.Provider>
	);
};
